import { useState, useEffect } from "react";

const useFetch = (fetchFunction, ...params) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true; // Prevent updates to unmounted components
    setLoading(true);

    fetchFunction(...params)
      .then((result) => {
        if (isMounted) {
          setData(result);
          setError(null);
        }
      })
      .catch((err) => {
        if (isMounted) setError(err.message);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [fetchFunction, ...params]);

  return { data, loading, error };
};

export default useFetch;
